/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import UserAnswerDto from './UserAnswerDto';

/**
 * The PageProgressDto model module.
 * @module model/PageProgressDto
 * @version v0
 */
class PageProgressDto {
    /**
     * Constructs a new <code>PageProgressDto</code>.
     * @alias module:model/PageProgressDto
     */
    constructor() { 
        
        PageProgressDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PageProgressDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PageProgressDto} obj Optional instance to populate.
     * @return {module:model/PageProgressDto} The populated <code>PageProgressDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PageProgressDto();

            if (data.hasOwnProperty('pageId')) {
                obj['pageId'] = ApiClient.convertToType(data['pageId'], 'Number');
            }
            if (data.hasOwnProperty('pageTitle')) {
                obj['pageTitle'] = ApiClient.convertToType(data['pageTitle'], 'String');
            }
            if (data.hasOwnProperty('pageType')) {
                obj['pageType'] = ApiClient.convertToType(data['pageType'], 'String');
            }
            if (data.hasOwnProperty('categoryId')) {
                obj['categoryId'] = ApiClient.convertToType(data['categoryId'], 'Number');
            }
            if (data.hasOwnProperty('categoryName')) {
                obj['categoryName'] = ApiClient.convertToType(data['categoryName'], 'String');
            }
            if (data.hasOwnProperty('visitedAt')) {
                obj['visitedAt'] = ApiClient.convertToType(data['visitedAt'], 'Date');
            }
            if (data.hasOwnProperty('completed')) {
                obj['completed'] = ApiClient.convertToType(data['completed'], 'Boolean');
            }
            if (data.hasOwnProperty('answers')) {
                obj['answers'] = ApiClient.convertToType(data['answers'], [UserAnswerDto]);
            }
            if (data.hasOwnProperty('correctAnswers')) {
                obj['correctAnswers'] = ApiClient.convertToType(data['correctAnswers'], 'Number');
            }
            if (data.hasOwnProperty('totalQuestions')) {
                obj['totalQuestions'] = ApiClient.convertToType(data['totalQuestions'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PageProgressDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PageProgressDto</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['pageTitle'] && !(typeof data['pageTitle'] === 'string' || data['pageTitle'] instanceof String)) {
            throw new Error("Expected the field `pageTitle` to be a primitive type in the JSON string but got " + data['pageTitle']);
        }
        // ensure the json data is a string
        if (data['pageType'] && !(typeof data['pageType'] === 'string' || data['pageType'] instanceof String)) {
            throw new Error("Expected the field `pageType` to be a primitive type in the JSON string but got " + data['pageType']);
        }
        // ensure the json data is a string
        if (data['categoryName'] && !(typeof data['categoryName'] === 'string' || data['categoryName'] instanceof String)) {
            throw new Error("Expected the field `categoryName` to be a primitive type in the JSON string but got " + data['categoryName']);
        }
        if (data['answers']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['answers'])) {
                throw new Error("Expected the field `answers` to be an array in the JSON data but got " + data['answers']);
            }
            // validate the optional field `answers` (array)
            for (const item of data['answers']) {
                UserAnswerDto.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} pageId
 */
PageProgressDto.prototype['pageId'] = undefined;

/**
 * @member {String} pageTitle
 */
PageProgressDto.prototype['pageTitle'] = undefined;

/**
 * @member {String} pageType
 */
PageProgressDto.prototype['pageType'] = undefined;

/**
 * @member {Number} categoryId
 */
PageProgressDto.prototype['categoryId'] = undefined;

/**
 * @member {String} categoryName
 */
PageProgressDto.prototype['categoryName'] = undefined;

/**
 * @member {Date} visitedAt
 */
PageProgressDto.prototype['visitedAt'] = undefined;

/**
 * @member {Boolean} completed
 */
PageProgressDto.prototype['completed'] = undefined;

/**
 * @member {Array.<module:model/UserAnswerDto>} answers
 */
PageProgressDto.prototype['answers'] = undefined;

/**
 * @member {Number} correctAnswers
 */
PageProgressDto.prototype['correctAnswers'] = undefined;

/**
 * @member {Number} totalQuestions
 */
PageProgressDto.prototype['totalQuestions'] = undefined;






export default PageProgressDto;

